<template>
    <div>
        <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition"
            v-model="snackbar" timeout="2000" :value="true" :color="snaclr">
            <v-icon class="mr-2" color="white">mdi-alert-outline</v-icon>
            {{ snackmsgbar }}
        </v-snackbar>
        <div>

            <div class="d-flex mt-4">
                <div>
                    <p class="title ml-14 mt-7 font-weight-bold" color="black">MF OrderBook</p>
                </div>
                <div class="ml-auto">
                    <div class="d-flex">
                        <div class="mt-4">
                            <v-menu v-model="menutb1" :close-on-content-click="false" transition="scale-transition"
                                min-width="auto" class="mt-4">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field flat solo background-color="#F1F3F8" v-model="dateRangeTexttb1"
                                        prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" class="rounded-pill"
                                        dense v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="datestb1" range @input="closeMenutb1"></v-date-picker>
                            </v-menu>
                        </div>
                        <div class="ml-3 mt-6">
                            <v-text-field dense v-model="tabledataall" hide-details prepend-inner-icon="mdi-magnify"
                                style="max-width: 180px"></v-text-field>
                        </div>
                        <!-- <div class="ml-3 mt-6"  >
                        <v-btn @click="unpledgeregdownall()" icon><v-icon>mdi-download</v-icon></v-btn>
                    </div> -->

                        <div class="ml-3 mt-6 mr-9">
                            <v-btn :loading="tableloadall" @click="allordersdata()"
                                icon><v-icon>mdi-refresh</v-icon></v-btn>
                        </div>
                    </div>
                </div>

            </div>

            <v-data-table fixed-header :items-per-page="100" height="75vh" :search="tabledataall"
                style="border: 1px solid #EEEEEE;" :loading="tableloadall" :headers="headersall" :items="alloredrdata"
                class="elevation-0 mx-14 mt-1" disable-sort outlined>

                <template v-slot:[`item.type`]="{ item }">
                    <p class="mb-0"> {{ item.OrderType ? item.OrderType == "NRM" ? 'Lumpsum' : 'SIP' : "" }}</p>
                </template>
                <template v-slot:[`item.ordertype`]="{ item }">
                    <span class="font-weight-medium fs-10"> Ord.no : {{ item.OrderId ? item.OrderId : "-" }} </span>
                </template>



                <template v-slot:[`item.buysell`]="{ item }">
                    <p class="mb-0">{{ item.buy_sell == "P" ? "Purchase" : "Redeem" }}</p>
                </template>







            </v-data-table>
        </div>
    </div>
</template>

<script>
const today = new Date().toISOString().split("T")[0];
export default {
    data() {
        return {
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            menu: false,
            dates: [today, today],
            datestb1: [today, today],
            datestb3: [today, today],
            snackbar: false,
            snackmsgbar: "",
            snaclr: "#000",
            alloredrdata: [],
            tabledataall: "",
            tableloadall: true,
            headersall: [
                { text: "Date", value: "datetime", sortable: false },
                { text: "Client Code", value: "ClientCode", sortable: false },

                { text: "Fund name", value: "name", sortable: false, width: "40%" },
                // { text: 'Type', value: 'AUM', sortable: false },
                { text: "Buy/Sell", value: "buysell", sortable: false },
                { text: "Transaction Type", value: "type", sortable: false },
                // {text: "Units", value: "Units", align: "right", sortable: false},
                { text: "Invest amt", value: "OrderVal", align: "right", class: "ws-p", sortable: false },
                { text: "Folio no.", value: "DPFolioNo", class: "ws-p", sortable: false },
                // {text: "Source", value: "source", sortable: false},
                { text: "Status", value: "status", sortable: false },

            ],

            menutb1: false,
        }
    },
    computed: {
        dateRangeText() {
            return this.dates.join(" ~ ");
        },
        dateRangeTexttb1() {
            return this.datestb1.join(" ~ ");
        },
        dateRangeTexttb3() {
            return this.datestb3.join(" ~ ");
        },
        creatManmffrom() {
            return this.formatDate(this.creatManmffrommodel);
        },

        creatManmfto() {
            return this.formatDate(this.creatManmftomodel);
        },
    },
    methods: {
        closeMenutb1() {
            if (this.datestb1.length === 2) {
                console.log("Selected Dates:", this.dates);
                this.allordersdata()
                this.menutb1 = false; // Close date picker after selection
            }
        },
        clientcodeget() {
            // console.log("gydvdv",this.clientCode);
            let clientCode11 = localStorage.getItem("clientid");

            console.log("!!!", clientCode11);

            this.clientidload = true;
            this.clientcode = [];
            const axios = require('axios');
            let data = JSON.stringify({
                "code": clientCode11,
                // "type": localStorage.getItem("mode")
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: `https://pdbe.mynt.in/client_list_ap`,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this;

            axios.request(config)
                .then((response) => {
                    axiosThis.clientidload = false;
                    if (response.data.stat == "Ok") {

                        axiosThis.clientcode = response.data.client_id;
                        this.allordersdata()


                        // for (let i = 0; i < axiosThis.clientcode.length; i++) {
                        //         console.log("test",axiosThis.clientcode[i]);
                        //         }

                    } else {
                        axiosThis.snackbar = true;
                        axiosThis.snackbarclr = "red";
                        axiosThis.snackmsgbar = response.data;
                    }
                })
                .catch((error) => {
                    axiosThis.clientidload = false;
                    console.log(error);
                    axiosThis.snackbar = true;
                    axiosThis.snackbarclr = "red";
                    axiosThis.snackmsgbar = 'Network Error';
                });
        },
        allordersdata() {
            this.sipnewArray = []
            this.redmacationcancellist = []
            this.tableloadall = true
            this.alloredrdata = []
            const axios = require('axios');
            let data = JSON.stringify({
                "start_date": this.datestb1[0],
                "end_date": this.datestb1[1],
                "ClientCode": "",
                'ClientList': this.clientcode
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://v3.mynt.in/mfapi/order/OrderBook',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };
            var axiosThis = this
            axios.request(config)
                .then((response) => {
                    // console.log("outt",response.data);

                    // console.log(JSON.stringify(response.data));
                     axiosThis.tableloadall = false

                    // console.log(JSON.stringify(response.data));
                    if (response.data.stat == "Ok") {
                        axiosThis.alloredrdata = response.data.data
                        axiosThis.tableloadall = false
                    }else if(response.data.emsg == "Order Not Found"){
                        console.log(".");
                        
                        axiosThis.tableloadall = false
                    } 
                    else {
                        axiosThis.snackbar = true
                        axiosThis.snackmsgbar = response.data
                        axiosThis.snaclr = "error"
                        axiosThis.tableloadall = false

                    }

                    //   axiosThis.alloredrdata = response.data.data
                })
                .catch((error) => {
                    console.log(error);
                    axiosThis.snackbar = true
                    axiosThis.snackmsgbar = error
                    axiosThis.snaclr = "error"
                    axiosThis.tableloadall = false

                });

        },
    },
    mounted() {
        this.clientcodeget()
    }
}
</script>